import { string } from 'yup';

const rule = {
	name: 'lettersonly',
	method ({ message } = { message: 'Letters only please' }) {

		return this.test('lettersonly', message, function (value) {

			const { createError } = this;
			return /^[a-z '-]+$/i.test(value) || createError({ message });

		});

	},
	schemaType: string
};

export default rule;
